import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { from, merge, of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { ExtractApi, ExtractionRequest, ExtractionResponse } from "../services/extractionFile.service";
import { fileStatusActions } from "@/store/convertFile/convertFile.slice";

interface ExtractionState {
  loading: boolean;
  success?: boolean;
  message?: string;
  geometry?: ExtractionResponse;
  sheets?: ExtractionResponse;
  error?: string;
}

const initialState: ExtractionState = {
  loading: false,
  geometry: undefined,
  sheets: undefined,
  error: undefined,
};

const extractionSlice = createSlice({
  name: "extraction",
  initialState,
  reducers: {
    extractMetadataRequest(state, _action: PayloadAction<ExtractionRequest>) {
      state.loading = true;
      state.success = undefined;
      state.message = undefined;
    },
    extractMetadataSuccess(state, action: PayloadAction<ExtractionResponse>) {
      state.loading = false;
      state.success = action.payload.success;
      state.message = action.payload.message;
    },
    extractMetadataFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = false;
      state.message = action.payload;
    },
    // Geometry
    extractGeometrySuccess: (state, action: PayloadAction<ExtractionResponse>) => {
      state.geometry = action.payload;
    },
    extractGeometryFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    // Sheets
    extractSheetsSuccess: (state, action: PayloadAction<ExtractionResponse>) => {
      state.sheets = action.payload;
    },
    extractSheetsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const extractionActions = extractionSlice.actions;
export const extractionReducer = extractionSlice.reducer;

// Epic
export const extractMetadataEpic = (action$: any) =>
  action$.pipe(
    ofType(extractionActions.extractMetadataRequest.type),
    mergeMap((action: PayloadAction<ExtractionRequest>) =>
      from(ExtractApi.Post.extractMetadata(action.payload)).pipe(
        mergeMap((response: ExtractionResponse) => {
          const fileId = String(action.payload.fileId);
          const actions = [];

          actions.push(extractionActions.extractMetadataSuccess(response));

          if (response.workflowId) {
            actions.push(
              fileStatusActions.saveExtractionWorkflowMapping({
                fileId,
                workflowId: response.workflowId,
              })
            );
          }

          actions.push(fileStatusActions.fetchLogsStart({ fileId }));

          return from(actions);
        }),
        catchError((error: any) =>
          of(
            extractionActions.extractMetadataFailure(
              error.message ?? "Unknown error"
            )
          )
        )
      )
    )
  );

  // export const extractMetadataEpic = (action$: any) =>
  // action$.pipe(
  //   ofType(extractionActions.extractMetadataRequest.type),
  //   mergeMap((action: PayloadAction<ExtractionRequest>) =>
  //     merge(
  //       // Metadata
  //       from(ExtractApi.Post.extractMetadata(action.payload)).pipe(
  //         map((res) => extractionActions.extractMetadataSuccess(res)),
  //         catchError((err) =>
  //           of(
  //             extractionActions.extractMetadataFailure(
  //               err.message ?? "Metadata error"
  //             )
  //           )
  //         )
  //       ),

  //       // Geometry
  //       from(ExtractApi.Post.extractGeometry(action.payload)).pipe(
  //         map((res) => extractionActions.extractGeometrySuccess(res)),
  //         catchError((err) =>
  //           of(
  //             extractionActions.extractGeometryFailure(
  //               err.message ?? "Geometry error"
  //             )
  //           )
  //         )
  //       ),

  //       // Sheets
  //       from(ExtractApi.Post.extractSheets(action.payload)).pipe(
  //         map((res) => extractionActions.extractSheetsSuccess(res)),
  //         catchError((err) =>
  //           of(
  //             extractionActions.extractSheetsFailure(
  //               err.message ?? "Sheets error"
  //             )
  //           )
  //         )
  //       )
  //     )
  //   )
  // );

  export const extractionEpics = [extractMetadataEpic];
